import { Col, Row } from "react-grid-system";
import { StyledDecisionReview, StyledDecisionReviewBlock, StyledDecisionReviewModal } from "../../../styles/StyledDecision/StyledContent";
import { PropTypes } from "prop-types";
import { useQuery } from "react-query";
import {
	addAnnualReview,
	addSingularReview,
	deleteAnnualReview,
	deleteSingularReview,
	editAnnualReview,
	editSingularReview,
	getAnnualReview,
	getSingularReview,
} from "../../../api/decision/review";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useEffect, useState } from "react";
import { QueryLoader } from "../../Loader";

import CalendarIcon from "../../../assets/img/icons/calendar.svg";
import AddIcon from "../../../assets/img/icons/add.svg";
import { MoreActions } from "../../MoreActions";
import Modal from "react-modal";
import { ConfirmationModal } from "../../ConfirmationModal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import { StyledField } from "../../../styles/StyledField";
import { StyledDatePickerWrapper } from "../../../styles/StyledDatePickerWrapper";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { StyledModalFooterActions } from "../../../styles/StyledAddUpperDecision";
import { Button } from "../../Button";

export default function DecisionReview({ id, newDecision = false }) {
	const axiosHandler = useAxiosPrivate();

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [editModalReviewType, setEditModalReviewType] = useState();
	const [editModalReviewAdded, setEditModalReviewAdded] = useState();
	const [name, setName] = useState("");
	const [date, setDate] = useState(moment().format("YYYY-MM-DD"));

	const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
	const [handleDelete, setHandleDelete] = useState();
	const [openDropdowns, setOpenDropdowns] = useState({ "single-review": false, "annual-review": false });

	const shouldFetchData = !newDecision && Boolean(id);
	const {
		isLoading: isLoadingSingularReview,
		isError: isErrorSingularReview,
		error: errorSingularReview,
		data: dataSingularReview,
		refetch: refetchSingularReview,
	} = useQuery(["singularReview", id], () => getSingularReview(axiosHandler.axiosPrivate, id), {
		enabled: shouldFetchData
	});
	const {
		isLoading: isLoadingAnnualReview,
		isError: isErrorAnnualReview,
		error: errorAnnualReview,
		data: dataAnnualReview,
		refetch: refetchAnnualReview,
	} = useQuery(["annualReview", id], () => getAnnualReview(axiosHandler.axiosPrivate, id), {
		enabled: shouldFetchData
	});

	useEffect(() => {
		if (isErrorSingularReview) console.log(errorSingularReview);
		if (isErrorAnnualReview) console.log(errorAnnualReview);
	}, [isLoadingAnnualReview, isLoadingSingularReview]);

	const handleSingularDelete = async () => {
		await deleteSingularReview(axiosHandler.axiosPrivate, refetchSingularReview, id);
	};

	const handleAnnualDelete = async () => {
		await deleteAnnualReview(axiosHandler.axiosPrivate, refetchAnnualReview, id);
	};

	const handleUpdate = async () => {
		let handleFunc;

		if (editModalReviewAdded) {
			if (editModalReviewType === "annual") {
				handleFunc = editAnnualReview;
			} else {
				handleFunc = editSingularReview;
			}
		} else {
			if (editModalReviewType === "annual") {
				handleFunc = addAnnualReview;
			} else {
				handleFunc = addSingularReview;
			}
		}

		await handleFunc(
			axiosHandler.axiosPrivate,
			id,
			() => {
				refetchAnnualReview();
				refetchSingularReview();
			},
			{ label: name, date: date }
		);
		await setModalIsOpen(false);
	};

	// For new decisions, show a message that reviews will be available after saving
	if (newDecision) {
		return (
			<StyledDecisionReview>
				<Col sm={12} lg={12}>
					<Row>
						<div style={{ padding: "20px", textAlign: "center", color: "#666", fontStyle: "italic" }}>
							Reviews will be available after the decision is saved
						</div>
					</Row>
				</Col>
			</StyledDecisionReview>
		);
	}

	return (
		<>
			<StyledDecisionReview>
				<Col sm={12} lg={12}>
					<Row>
						<StyledDecisionReviewBlock>
							<MoreActions
								type="single-review"
								options={[
									{
										display: dataSingularReview?.status === 404,
										click: () => {
											setEditModalReviewType("singular");
											setEditModalReviewAdded(false);
											setName("");
											setDate(moment().format("YYYY-MM-DD"));
											setModalIsOpen(true);
										},
										testId: "review-add",
										name: "Add review",
									},
									{
										display: dataSingularReview?.status !== 404,
										click: () => {
											setEditModalReviewType("singular");
											setEditModalReviewAdded(true);
											setName(dataSingularReview?.label);
											setDate(dataSingularReview?.date ? [...dataSingularReview.date.split("T")][0] : moment().format("YYYY-MM-DD"));
											setModalIsOpen(true);
										},
										testId: "review-edit",
										name: "Edit review",
									},
									{
										display: true,
										click: () => {
											setHandleDelete("singular");
											setConfirmModalIsOpen(true);
										},
										testId: "review-delete",
										name: "Delete review",
									},
								]}
								isOpen={openDropdowns}
								setIsOpen={setOpenDropdowns}
								isDisabled={false}
							/>

							<h2>Single review</h2>
							{isLoadingSingularReview ? (
								<QueryLoader />
							) : dataSingularReview && dataSingularReview?.status !== 404 ? (
								<div className="review">
									<div>
										<span>Title </span>
										<h5>{dataSingularReview.label}</h5>
									</div>
									<div>
										<span>Date </span>
										<h5>
											<i>
												<img src={CalendarIcon} alt="date" />
											</i>
											{dataSingularReview?.date ? [...dataSingularReview.date.split("T")][0] : "No date"}
										</h5>
									</div>
								</div>
							) : (
								<h6>No review added</h6>
							)}
						</StyledDecisionReviewBlock>
						<StyledDecisionReviewBlock>
							<MoreActions
								type="annual-review"
								options={[
									{
										display: dataAnnualReview?.status === 404,
										click: () => {
											setEditModalReviewType("annual");
											setEditModalReviewAdded(false);
											setName("");
											setDate(moment().format("YYYY-MM-DD"));
											setModalIsOpen(true);
										},
										testId: "review-annual-add",
										name: "Add review",
									},
									{
										display: dataAnnualReview?.status !== 404,
										click: () => {
											setEditModalReviewType("annual");
											setEditModalReviewAdded(true);
											setName(dataAnnualReview?.label);
											setDate(dataAnnualReview?.date ? [...dataAnnualReview.date.split("T")][0] : moment().format("YYYY-MM-DD"));
											setModalIsOpen(true);
										},
										testId: "review-edit",
										name: "Edit review",
									},
									{
										display: true,
										click: () => {
											setHandleDelete("annual");
											setConfirmModalIsOpen(true);
										},
										testId: "review-delete",
										name: "Delete review",
									},
								]}
								isOpen={openDropdowns}
								setIsOpen={setOpenDropdowns}
								isDisabled={false}
							/>

							<h2>Annual review</h2>
							{isLoadingAnnualReview ? (
								<QueryLoader />
							) : dataAnnualReview && dataAnnualReview?.status !== 404 ? (
								<div className="review">
									<div>
										<span>Title </span>
										<h5>{dataAnnualReview.label}</h5>
									</div>
									<div>
										<span>Repeat day </span>
										<h5>{dataAnnualReview?.date ? moment([...dataAnnualReview.date.split("T")][0]).format("D MMM") : "No date"}</h5>
									</div>
								</div>
							) : (
								<h6>No review added</h6>
							)}
						</StyledDecisionReviewBlock>
					</Row>
				</Col>
			</StyledDecisionReview>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => {
					setModalIsOpen(false);
				}}
				style={customStyles}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setModalIsOpen(false);
					}}
				>
					{editModalReviewAdded ? "Edit" : "Add"}
					{editModalReviewType === "annual" && " Annual"} Review
				</ModalHeader>
				<StyledDecisionReviewModal>
					<StyledField>
						<label>
							Name
							<input type="text" value={name} onChange={(e) => setName(e.target.value)} />
						</label>
					</StyledField>
					<StyledField>
						<div className="label">
							Date
							<StyledDatePickerWrapper>
								<ReactDatePicker
									value={date}
									// selected={(field.value && new Date(field.value)) || null}
									onChange={(val) => {
										setDate(moment(val).format("YYYY-MM-DD"));
									}}
									placeholderText="Choose"
									dateFormat="yyyy-MM-dd"
									popperPlacement="right"
									shouldCloseOnSelect={true}
								/>
								<i>
									<img src={CalendarIcon} alt="date" />
								</i>
							</StyledDatePickerWrapper>
						</div>
					</StyledField>
				</StyledDecisionReviewModal>
				<Row>
					<Col>
						<StyledModalFooterActions>
							<Button onClick={() => setModalIsOpen(false)} bg={false} small={true}>
								cancel
							</Button>
							<Button
								icon={AddIcon}
								onClick={() => {
									handleUpdate();
								}}
							>
								{editModalReviewAdded ? "Edit" : "Add"}
								{editModalReviewType === "annual" && " Annual"} Review
							</Button>
						</StyledModalFooterActions>
					</Col>
				</Row>
			</Modal>
			<Modal
				isOpen={confirmModalIsOpen}
				onRequestClose={() => {
					setConfirmModalIsOpen(false);
				}}
				style={customStyles}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal
					handleDelete={handleDelete === "singular" ? handleSingularDelete : handleAnnualDelete}
					closeModal={() => {
						setConfirmModalIsOpen(false);
					}}
				/>
			</Modal>
		</>
	);
}

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		width: "100%",
		maxWidth: "600px",
		padding: "29px 25px 29px",
		maxHeight: "80vh",
		overflowY: "auto",
		background: "#F7F8F9",
	},
};

DecisionReview.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	newDecision: PropTypes.bool,
};
